import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconMapPin } from "@tabler/icons-react";
import { AreasDef } from "./AreasDef";

export const AreasIcon = IconMapPin;
export const AreasHelpText = '* Áreas de Ruteo.';

export class Areas extends Entity<AreasDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new AreasDef(), parentKeys);
        this.Form = import('./AreasForm').then((module) => module.AreasForm);
        this.Title = "Areas de Ruteo";
        this.HelpText = AreasHelpText;
        this.Icon = AreasIcon;
    }
}